import { defineStore } from "pinia";

export const useAppStore = defineStore("appStore", {
  state: () => ({
    qualities: [],
    initRoute: null,
    lastLocation: null,
    selectedTabLast: null,
    lastSelectedTab: null,
    selectedMenuUser: 0,
    isNewVideoOnYoutubePlaylist: false,
    isNewSocialConnected: false,
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
  },
});

export default useAppStore;
